import { SITE } from "@/lib/site";

type SocialNetwork = {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
};

function LinkedInIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

function FacebookIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.098 4.388 23.093 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.017 1.792-4.687 4.533-4.687 1.313 0 2.686.235 2.686.235v2.953H15.83c-1.49 0-1.955.925-1.955 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.093 24 18.098 24 12.073z" />
    </svg>
  );
}

function InstagramIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  );
}

function PinterestIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.363-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
    </svg>
  );
}

function TikTokIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.525.02c1.8-.1 3.354.903 4.126 2.537.19.401.272.849.244 1.288v6.997c.044.002.09.003.135.003 1.785 0 3.49-.755 4.686-2.077 1.13-1.25 1.76-2.89 1.76-4.612H24v15.478c0 2.27-1.85 4.12-4.12 4.12s-4.12-1.85-4.12-4.12c0-.41.06-.81.172-1.19-1.285.956-2.84 1.47-4.452 1.47-3.866 0-7.01-3.144-7.01-7.01 0-2.91 1.78-5.41 4.31-6.47V.02h3.055zm4.855 7.536V3.474c-.81.59-1.79.95-2.855.99v3.092h2.855zM8.27 12.003c0 2.05 1.67 3.72 3.72 3.72 1.03 0 1.99-.42 2.69-1.14v-4.08h2.86c.02.22.03.44.03.66 0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c.23 0 .45.01.67.03v2.86c-.22-.02-.44-.03-.67-.03-2.05 0-3.72 1.67-3.72 3.72z" />
    </svg>
  );
}

function XIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

const SOCIALS: SocialNetwork[] = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/casinobetalingen-com/", icon: LinkedInIcon },
  { name: "Facebook", href: "https://www.facebook.com/casinobetalingen/", icon: FacebookIcon },
  { name: "Instagram", href: "https://www.instagram.com/casinobetalingen/", icon: InstagramIcon },
  { name: "Pinterest", href: "https://www.pinterest.com/casinobetalingen/", icon: PinterestIcon },
  { name: "TikTok", href: "https://www.tiktok.com/@casinobetalingen.c", icon: TikTokIcon },
  { name: "X", href: "https://x.com/casinobetalinge", icon: XIcon },
];

export function SocialProfiles() {
  return (
    <div className="mt-6">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-primary-foreground/70">
        Volg {SITE.name}
      </p>
      <ul className="flex flex-wrap gap-3">
        {SOCIALS.map((social) => {
          const Icon = social.icon;
          return (
            <li key={social.name}>
              <a
                href={social.href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label={`${SITE.name} op ${social.name} (opent in nieuw tabblad)`}
                title={social.name}
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary-foreground/10 text-primary-foreground/90 transition-colors hover:bg-primary-foreground/20 hover:text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground/50"
              >
                <Icon className="h-[1.1rem] w-[1.1rem]" />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
